import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import {
  exportMonitorProvinceDistributionReport,
  getMonitorProvinceDistributionReports,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorProvinceDistributionListComponent from "components/MonitorReports/IPDistribution"

const MonitorProvinceDistributionReportList = () => {
  document.title = "IP Distribution Reports"

  const dispatch = useDispatch()

  // Retrieve distributions data from Redux store
  const distributions = useSelector(
    state => state.monitorReports.monitorProvicneDistributionReport
  )
  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorProvinceExportDistributionReport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_IP_DISTRIBUTION
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorProvinceDistributionReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getMonitorProvinceDistributionReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorProvinceDistributionReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch item categories and ips
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorProvinceDistributionReports(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMonitorProvinceDistributionReport(pageNumber,
        according,
        search,
        advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Monitor"}
        breadcrumbItem={"IPs Distribution Report"}
      />

      {/* Monitor Province ( IP ) Distribution Component  */}
      <MonitorProvinceDistributionListComponent
        data={distributions?.data}
        error={distributions?.error}
        loading={distributions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportStatus}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorProvinceDistributionReportList
